"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.OtpDestination = void 0;
var OtpDestination;
(function (OtpDestination) {
    OtpDestination["SMS"] = "sms";
    OtpDestination["Email"] = "email";
})(OtpDestination || (exports.OtpDestination = OtpDestination = {}));
